<template>
  <section class="greeting-section" 
  :style="{ backgroundImage: `url(${backgroundImage})` }">
    <div class="container">
      <h2 class="title">Welcome to Our Wedding</h2>
      <p class="message">
        We are so excited to celebrate this special day with you! Your presence means the world to us.
      </p>
      <p class="signature">With love,</p>
      <p class="names">Mouyly & Mongkol</p>
    </div>
  </section>
</template>

<script>
import backgroundImage from '../assets/b6.png';
// import backgroundImage from '../assets/background8.png';

export default {
  name: "GreetingSection",
  data() {
    return {
      backgroundImage
    };
  }
};
</script>

<style scoped>
.greeting-section {
  min-height: 100vh;
  background-image: inherit;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  position: relative;
  color: white;
  text-align: center;
  box-sizing: border-box;
}




.container {
  max-width: 800px;
  margin: auto;
  position: relative;
  z-index: 1;
}

/* .title {
  font-family: "Playfair Display", serif;
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 20px;
  color: #ffd77d;
}
.message {
  font-family: "Poppins", sans-serif;
  font-size: 1.2rem;
  color: rgb(13, 12, 12);
  margin-bottom: 50px;
}
.signature {
  font-family: "Great Vibes", cursive;
  font-style: italic;
  font-size: 1.1rem;
  color: rgb(240, 141, 192);
}
.names {
  font-family: "Great Vibes", cursive;
  font-size: 1.5rem;
  font-weight: 600;
  color: #ffd77d;
} */

.title {
  font-family: "Great Vibes", serif;
  font-size: 36px;
  font-weight: 700;
  color: black;
}

.message {
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  line-height: 1.6;
  color: black;
  font-weight: bold;
}

.signature {
  font-family: "Poppins", sans-serif;
  font-style: italic;
  color: #e891a8
}

.names {
  font-family: "Great Vibes", cursive;
  font-size: 40px;
  color: #e891a8; /* soft pink */
  font-weight: bold;
}


</style>
